import React, { useState, useEffect } from "react";
import * as theme from '../../../theme';
import Heading from "../../../components/Heading";

function ImportanceOfBinders({ title }) {

  return (
    <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 800, position: 'relative', marginLeft: 'auto', marginRight: 'auto' }}>
      <Heading
        title={title}
        subHeading={true}
        center={true}
      />
      <div style={{ ...theme.SubText, position: 'relative',  marginRight: 'auto', marginLeft: 'auto' }}>
        Binders are a critical component of every TruBalance scan, as they support the gentle detox process facilitated by the Imprint Remedy, which targets toxins in the body's cells and tissues.
        By binding toxins, they ensure safe elimination, preventing toxins from circulating and causing discomfort. 
        Without binders, clients may experience unpleasant detox side effects, which we seek to avoid.<br/><br/>
        <b>DON'T USE BINDERS IN YOUR PRACTICE?</b><br />
        We can discuss this at your 1:1 in the best way to incorporate or navigate this with your clients.<br /><br />
        <b>IN SUMMARY</b><br/> Binders are an important function of a safe, effective, and painfree detox. If a client is struggling with detox symptoms, they may need to slow down how much of the Imprint Remedy they are taking, and increase the amount of the binder they are taking.<br/><br/>
        <b>FURTHER SUPPORT</b><br/>
        You can explore these topics further during your one-on-one onboarding call to address any additional questions. Additionally, attending the weekly support calls is a great way to work through direct client issues relating to this topic.
      </div>
    </div>
  );
}

export default ImportanceOfBinders;